import releaseNotes from './data/releaseNotes.json'

export function getCurrentVersion () {
  return releaseNotes[releaseNotes.length - 1].version
}
